.analytics {
  grid-column: 1 / 13;
  min-width: 0;
}

/* At 900px and below the shell's body is a one-column grid (`AppShell.module.css`), and a
   placement to line 13 of it creates eleven implicit zero-width columns. Their twelve-pixel gaps
   are taken from the one real column, so at 375px every panel on the Emissions screen was 215px
   wide inside a 347px body (measured 2026-10-29, found while photographing the receipt drawer,
   which is placed `1 / -1` and inherited the same 215px). `Panel` does this for itself; this
   section is not a `Panel`. */
@media (width <= 900px) {
  .analytics {
    grid-column: 1 / -1;
  }
}

.context,
.note {
  margin: 0 0 10px;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  max-width: 100ch;
}

.note {
  margin: 10px 0 0;
}

.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--gap);
}

.grid > section {
  min-height: auto;
  overflow: visible;
}

.grid > section > div:last-child {
  flex: initial;
  min-height: auto;
  overflow: visible;
}

.scopeLayout {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 180px;
}

.donut {
  width: 180px;
  flex: 0 0 180px;
  overflow: visible;
}

.arc {
  cursor: pointer;
  stroke: var(--panel);
  stroke-width: 1px;
}

.arc:hover {
  opacity: 0.8;
}

.arc[aria-disabled="true"],
.scopeButton:disabled,
.siteButton:disabled,
.fallback button:disabled {
  cursor: not-allowed;
  color: var(--muted);
}

.conflict {
  display: block;
  grid-column: 1 / -1;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.arc:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 3px;
}

.legend,
.sites {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.legend li + li {
  margin-top: 9px;
}

.scopeButton {
  display: grid;
  grid-template-columns: 8px minmax(0, 1fr);
  gap: 3px 8px;
  align-items: center;
  width: 100%;
  padding: 5px;
  border: 0;
  border-radius: 4px;
  background: none;
  font: inherit;
  font-size: var(--t-dense);
  color: var(--ink);
  text-align: left;
  cursor: pointer;
}

.scopeButton strong,
.percentage {
  grid-column: 2;
  font-variant-numeric: lining-nums tabular-nums;
}

.percentage,
.unassessed {
  color: var(--muted);
  font-size: var(--t-min);
}

.swatch {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.scopeButton:hover,
.siteButton:hover {
  background: var(--panel-2);
}

.empty {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
  line-height: 1.5;
}

.siteButton {
  display: grid;
  grid-template-columns: minmax(90px, 1fr) minmax(50px, 1fr) minmax(48px, auto);
  gap: 10px;
  width: 100%;
  align-items: center;
  padding: 9px 4px;
  border: 0;
  border-radius: 4px;
  background: none;
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  text-align: left;
  cursor: pointer;
}

.siteName {
  overflow-wrap: anywhere;
}

.track {
  height: 6px;
  overflow: hidden;
  background: var(--panel-3);
  border-radius: 4px;
}

.fill {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--info);
  border-radius: inherit;
  transform-origin: left;
}

.value {
  font-weight: 500;
  font-variant-numeric: lining-nums tabular-nums;
  text-align: right;
}

.fallback {
  margin-top: 12px;
  color: var(--ink-2);
  font-size: var(--t-min);
}

.fallback summary {
  cursor: pointer;
  padding: 4px 0;
}

.fallback table {
  width: 100%;
  table-layout: fixed;
  margin-top: 8px;
  border-collapse: collapse;
}

.fallback th,
.fallback td {
  padding: 7px;
  border-bottom: 1px solid var(--line);
  text-align: left;
  overflow-wrap: anywhere;
  vertical-align: top;
}

.fallback button {
  color: var(--ink);
  background: none;
  border: 0;
  padding: 3px 0;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

@media (width <= 1000px) {
  .grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (width <= 480px) {
  .scopeLayout {
    flex-direction: column;
    align-items: stretch;
  }

  .donut {
    align-self: center;
  }

  .siteButton {
    grid-template-columns: minmax(0, 1fr) 48px;
  }

  .track {
    display: none;
  }
}
